import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromRoot from "@core/store/reducers";
import { Observable } from "rxjs";
import { Settings } from "@core/store/settings/settings.model";
import * as SettingsActions from "@core/store/user/user.actions";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent implements OnInit {
  userSettings$: Observable<Settings>;

  constructor(private store: Store<fromRoot.AppState>) {
    this.userSettings$ = store.select(fromRoot.getSettings);
  }

  ngOnInit() {}

  saveUserSettings(settings) {
    // reload page for lang change
    settings.reload = true;
    this.store.dispatch(new SettingsActions.SaveSettingsAction(settings));
  }
}



// WEBPACK FOOTER //
// /app/src/app/settings/pages/settings/settings.component.ts